import type React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { BootIcon } from '@vlabs/icons';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { AttributeCard } from './attribute-card/AttributeCard';

interface ShoesAttributeCardProps extends WithDataTestid, WithClassNameProp {
  shoes: {
    apparent_color: string;
  };
}

export function ShoesAttributeCard({
  shoes: { apparent_color },
  className = undefined,
  'data-testid': dataTestId = 'ShoesAttributeCard',
  ...props
}: ShoesAttributeCardProps): React.JSX.Element {
  const { t } = useTranslation();

  const shoesColorLabel = EVENT_ENUMS.LOWER_BODY.SHOES.APPARENT_COLOR[apparent_color]?.label;

  const colorsConfig = [{
    color: apparent_color,
    tooltip: shoesColorLabel,
  }];

  return (
    <AttributeCard
      className={className}
      colorsConfig={colorsConfig}
      data={apparent_color === 'undefined' ? null : apparent_color}
      data-testid={dataTestId}
      description={shoesColorLabel}
      icon={<BootIcon />}
      title={t('shared:attribute_cards.shoes.title')}
      {...props}
    />
  );
}
